/**
 * Store ligero del filtro global de cliente (legible desde el interceptor axios).
 * null = Todos (alcance del rol)
 */
const STORAGE_KEY = 'arithmos_global_client_id'

let selectedClientId = (() => {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  const n = Number(raw)
  return Number.isFinite(n) ? n : null
})()

const listeners = new Set()

export function getSelectedClientId() {
  return selectedClientId
}

export function setSelectedClientId(id) {
  const next = id === null || id === undefined || id === '' ? null : Number(id)
  selectedClientId = Number.isFinite(next) ? next : null
  if (selectedClientId == null) {
    localStorage.removeItem(STORAGE_KEY)
  } else {
    localStorage.setItem(STORAGE_KEY, String(selectedClientId))
  }
  listeners.forEach((fn) => {
    try {
      fn(selectedClientId)
    } catch (_) {
      /* ignore */
    }
  })
}

export function clearSelectedClientId() {
  setSelectedClientId(null)
}

export function subscribeSelectedClientId(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

/** Rutas donde no inyectar filtro (el listado de clientes alimenta el selector). */
export function shouldSkipClientFilter(url = '', method = 'get') {
  const u = String(url || '')
  const m = String(method || 'get').toLowerCase()
  if (u.includes('/auth/')) return true
  if (u.includes('login-campaigns')) return true
  // XML: el lado emisor/receptor se deduce del CFDI; no forzar client_id
  if (
    u.includes('procesar_xml') ||
    u.includes('procesar-xml') ||
    u.includes('/xml-processing') ||
    u.includes('xml-cfdis')
  ) {
    return true
  }
  if (u.includes('/clients/clients') && m === 'get' && !/\/clients\/clients\/\d+/.test(u)) {
    return true
  }
  if (u.includes('/clients/client-types')) return true
  if (u.includes('/clients/regimenes')) return true
  if (u.includes('/clients/usos-cfdi') || u.includes('/clients/formas-pago') || u.includes('/clients/metodos-pago')) {
    return true
  }
  return false
}
